import React from 'react'

const Arrow = ({ direction, clickFunction, glyph }) => {
  return (
    <button 
      className={ `slide-arrow slide-arrow-${direction} `} 
      onClick={ clickFunction }
    >
		{ glyph } 
	</button>
  )
}

export default Arrow


// WEBPACK FOOTER //
// ./components/common/global-carousel/Arrow.js